<template>
    <div>
        <v-btn @click="login">Login</v-btn>
        <button @click="test">Test</button>
    </div>
</template>
<script>

    import axios from 'axios';


    export default {
        mounted() {
            let vm = this;
        },
        data() {
            return {
                credentials: {
                    client: {
                        id: 'b552e8da-0ef5-4e6b-b7d7-67768d5ebd66',
                        secret: 'Mzg3NTUxY2EtOTRhZC00MzU2LWE4MjQtMTE4N2RjYTNiNGJkMzVmZjA4MGUtZmE0OS00NTEyLTkzNGItNjNlOWVkMTRmYmE2'
                    },
                    auth: {
                        tokenHost: 'https://vonex.kayako.com'
                    }
                }
            }
        },
        methods: {
            login: function () {

                axios.get('https://vonex.kayako.com/oauth/token/authorize?response_type=code&client_id=b552e8da-0ef5-4e6b-b7d7-67768d5ebd66').then(data => {
                }).catch(() => {
                })


            },
            test: function () {
                axios({
                    method: 'post',
                    url: 'https://vonex.kayako.com/api/v1/cases',
                    data: {
                        "subject": "My coffee machine is not working", "contents": "Hey! I am facing issue from last week kindly look into it on priority",
                        "channel": "MAIL", "channel_id": "33", "requester_id": "6", "priority_id": "3", "type_id": "1"
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
                        'Authorization': 'Basic ' + btoa('andrew.smith@alsconsulting.com.au:H10BO3nlnVaW!')
                    }
                }).then(() => {
                }).catch(() => {
                });
            },
        }
    }

</script>
